var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { FloatingFocusManager, useDismiss, useFloating, useInteractions, } from '@floating-ui/react';
import { panelWrapperStyle, panelStyle } from './styles';
import { useDialog } from './dialog-context';
import CloseButton from './close-button';
function Panel(_a) {
    var role = _a.role, isVisible = _a.isVisible, onClose = _a.onClose, closeButtonOverride = _a.closeButtonOverride, ariaLabel = _a.ariaLabel, children = _a.children, restProps = __rest(_a, ["role", "isVisible", "onClose", "closeButtonOverride", "ariaLabel", "children"]);
    var _b = useDialog(), headerId = _b.headerId, bodyId = _b.bodyId, alignCenter = _b.alignCenter, autoFocusRef = _b.autoFocusRef;
    var _c = useFloating({
        open: isVisible,
        onOpenChange: onClose, // Handles closing when clicking outside of the Dialog (dismissing)
    }), floating = _c.floating, context = _c.context;
    var getFloatingProps = useInteractions([
        useDismiss(context, {
            bubbles: false,
        }),
    ]).getFloatingProps;
    function renderCloseButton() {
        function handleClick() {
            var _a, _b;
            (_b = closeButtonOverride === null || closeButtonOverride === void 0 ? void 0 : (_a = closeButtonOverride.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        return closeButtonOverride ? (cloneElement(closeButtonOverride, {
            onClick: handleClick,
        })) : (_jsx(CloseButton, { onClick: onClose }));
    }
    return (_jsx(FloatingFocusManager, __assign({ context: context, initialFocus: isVisible ? -1 : autoFocusRef }, { children: _jsx("div", __assign({ css: panelWrapperStyle() }, { children: _jsxs("section", __assign({ role: role, "aria-modal": true }, (!ariaLabel && headerId && { 'aria-labelledby': headerId }), (bodyId
                ? { 'aria-describedby': bodyId }
                : { 'aria-label': ariaLabel }), { css: panelStyle({ isVisible: isVisible, alignCenter: alignCenter }) }, getFloatingProps({
                ref: floating,
            }), restProps, { children: [renderCloseButton(), children] })) })) })));
}
export default Panel;
